import { render, staticRenderFns } from "./DepositRefundDetail.vue?vue&type=template&id=5f013f48&scoped=true"
import script from "./DepositRefundDetail.vue?vue&type=script&lang=js"
export * from "./DepositRefundDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f013f48",
  null
  
)

export default component.exports